import React, { useContext } from 'react'
import { DataContext } from '../../context/DataContext'
import { useNavigate } from 'react-router-dom'
import { ModalActions } from '../common/modal/Modal'
import { t } from '../../i18n/i18n'
import { Button, makeStyles, tokens } from '@fluentui/react-components'
import { Text } from '../common/text/Text'
import { RiskAnalysis, RiskAnalysisStatus } from '../../api/schemas/schema'
import { api } from '../../helpers/apiHelper'
import { handleMessage } from '../../helpers/stateHelper'
import { IItemState } from '../../interfaces/IItemState'
import { NavigationLink } from '../../interfaces/INavigationLink'
import { DraggableModal } from '../common/modal/DraggableModal'

const useStyles = makeStyles({
   magrginTop: {
      marginTop: tokens.spacingVerticalXL,
   },
})

type ModalCompleteRiskAssessmentProps = {
   setRiskAnalysisState: React.Dispatch<React.SetStateAction<IItemState<RiskAnalysis>>>
   riskAnalysisState: IItemState<RiskAnalysis>
   close: () => void
   open: boolean
}
export const ModalCompleteRiskAssessment = ({ setRiskAnalysisState, riskAnalysisState, close, open }: ModalCompleteRiskAssessmentProps) => {
   const classes = useStyles()
   const dataContext = useContext(DataContext)
   const { userAccount } = dataContext.state
   const navigate = useNavigate()
   const { item } = riskAnalysisState
   const onComplete = async () => {
      try {
         setRiskAnalysisState((prev) => ({ ...prev, loading: true }))
         item.status = RiskAnalysisStatus.Completed
         item.modifiedBy = userAccount
         item.modifiedById = userAccount.id
         const updatedAnalysis = (await api().updateRiskAnalysis(item)).data
         setRiskAnalysisState((prev) => ({ ...prev, loading: false, item: updatedAnalysis }))
         handleMessage(dataContext.setRootState, 'success', t('RiskAssessmentCompleted'))
         close()
         navigate(NavigationLink.RiskManagement + '?tab=concluded')
      } catch (error: any) {
         setRiskAnalysisState((prev) => ({ ...prev, loading: false, error: error.error }))
         handleMessage(dataContext.setRootState, 'error', t('CouldNotCompleteRiskAssessment'))
         close()
      }
   }
   return (
      <DraggableModal open={open} title={t('CompleteRiskAssessment')} onClose={close} noDivider>
         <Text align="center">{t('CompleteRiskAssessmentConfirmationMessage')}</Text>
         <ModalActions className={classes.magrginTop}>
            <Button onClick={close}>{t('Cancel')}</Button>
            <Button appearance="primary" onClick={onComplete}>
               {t('CompleteRiskAssessment')}
            </Button>
         </ModalActions>
      </DraggableModal>
   )
}
